export default "__VITE_ASSET__o2ls4Wes__"